import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";

import appReducer from "./slices/appSlice";
import checkoutReducer from "./slices/checkoutSlice";
import appSessionReducer from "./slices/appSessionSlice";
import { inventorySlice } from "./slices";
import biReducer from "./slices/biSlice";

const appSessionPersistConfig = { key: "appSession", storage: storageSession };

const checkoutPersistConfig = {
  key: "checkout",
  storage,
  blacklist: [
    "orderNotes",
    "addressDetails",
    "billingDetails",
    "userAddresses",
    "userBillingAddresses",
    "newUserName",
    "newUserLastName",
    "newUserEmail",
    "newUserPhone",
    "billing",
  ],
};

const reducers = combineReducers({
  app: appReducer,
  checkout: persistReducer(checkoutPersistConfig, checkoutReducer),
  appSession: persistReducer(appSessionPersistConfig, appSessionReducer),
  inventory: inventorySlice,
  bi: biReducer,
});

const rootPersistConfig = {
  key: "root",
  storage,
  blacklist: ["appSession", "checkout", "inventory", "bi"],
};

const persistedReducer = persistReducer(rootPersistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

// Limpiar la key antigua de persistencia manual si existe (migración)
try {
  localStorage.removeItem("persistedState");
} catch (e) {
  // ignorar
}

export default store;
